import { useMemo } from "react";

import { useAppliedConfigContext } from "contexts/applied-config";
import type { RiskUnitFormatter } from "helpers/risk-units";
import {
  formatRiskUnitValue,
  getPublishedRiskUnitCode,
} from "helpers/risk-units";

export const usePublishedRiskUnitFormatter = (): RiskUnitFormatter => {
  const { publishedUnitsResponse, riskUnitsResponse } =
    useAppliedConfigContext();
  const riskUnitCode = getPublishedRiskUnitCode(
    publishedUnitsResponse.data,
    riskUnitsResponse.data,
  );

  return useMemo(
    () => (value: number) => formatRiskUnitValue(value, riskUnitCode),
    [riskUnitCode],
  );
};
